module.exports = "pegasus_template/assets/themecapture1/app/100.png";